import Vue from 'vue';
import ECharts from 'vue-echarts';
Vue.component('v-chart', ECharts);
